import styled from "styled-components";

import theme from "../theme";

export default styled.button`
  background: ${theme.colors.blue};
  border: none;
  outline: none;
  border-radius: 8px;
  font-weight: 700;
  font-size: ${theme.fontSize.med}px;
  color: ${theme.colors.black};
  min-width: 200px;
  min-height: 36px;
  cursor: pointer;
  outline: none;
  &:disabled {
    background: ${theme.colors.greyLight};
    color: ${theme.colors.grey}};
    cursor: not-allowed;
  }
`;
